import { parseToBRL } from '@/helpers/currency'

export const calculateLoanInstallments = (
  interestBase,
  amount,
  duration,
  raw = false,
) => {
  const installmentValue =
    (interestBase / (1 - 1 / (1 + interestBase) ** parseInt(duration))) *
    (amount ?? 0)
  if (raw) {
    return installmentValue
  }
  return parseToBRL(installmentValue)
}
